import { render, staticRenderFns } from "./HandleSplit.vue?vue&type=template&id=66332afc&"
import script from "./HandleSplit.vue?vue&type=script&lang=js&"
export * from "./HandleSplit.vue?vue&type=script&lang=js&"
import style0 from "./HandleSplit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HandleSplit.vue"
export default component.exports